import { render } from "./MonthlyDistribution.vue?vue&type=template&id=b81e9086&scoped=true"
import script from "./MonthlyDistribution.vue?vue&type=script&lang=js"
export * from "./MonthlyDistribution.vue?vue&type=script&lang=js"

import "./MonthlyDistribution.vue?vue&type=style&index=0&id=b81e9086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81e9086"]])

export default __exports__